import { useState, useEffect, useCallback } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebaseConfig";
import Config from "../../../config";
import { useUserStore } from "../../../store";
import { SortType } from "../../../types";

const useMyInscriptions = ({
  sortBy,
  collectionSymbol,
}: {
  sortBy?: SortType | null;
  collectionSymbol?: string;
}) => {
  const ordAddress = useUserStore((state) => state.ordAddress);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [myInscriptions, setMyInscriptions] = useState<any[]>([]);

  const fetchMyInscriptions = useCallback(
    async (address: string, offset) => {
      try {
        const getInscriptions = httpsCallable(functions, "getInscriptions");
        const response = await getInscriptions({
          offset,
          sortBy,
          collectionSymbol: Config.Network.isMainnet()
            ? collectionSymbol
            : "",
          // collectionSymbol: collectionSymbol,
          address: Config.Network.isMainnet()
            ? address
            : "bc1pm4xqk2d68rvegvzlhzlvgfssdfndpsum672j92pu6rwth0wzc6kqxsqdlz",
            // : "bc1pzuf5k5fu0q3kwtfuezdr8q0785wlqr0fujp4v5nzsw8kc359663q664mtq",
        });
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    [sortBy, collectionSymbol]
  );

  useEffect(() => {
    setMyInscriptions([]);
  }, [ordAddress, sortBy, collectionSymbol]);

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      let offset = 0;
      try {
        while (true) {
          const data: any = await fetchMyInscriptions(ordAddress, offset);
          setMyInscriptions((prev) => [...prev, ...data.tokens]);
          offset += data.tokens.length;
          if (data.tokens.length < 40) break;
        }
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [ordAddress, fetchMyInscriptions, sortBy, collectionSymbol]);

  return {
    myInscriptions,
    totalItems: myInscriptions.length,
    isLoading,
    isFetching: isLoading,
    error,
  };
};

export default useMyInscriptions;
